import { Skeleton, Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  loading?: boolean;
  length?: 'short' | 'medium' | 'long';
};

export const LoadingListSkeleton = ({
  loading = true,
  length = 'medium',
  children,
}: PropsWithChildren<Props>) => {
  const items = [];

  for (
    let i = 0;
    i < (length === 'short' ? 3 : length === 'medium' ? 8 : 15);
    i++
  ) {
    items.push(Math.random() * 50 + 25);
  }

  return loading ? (
    <Stack sx={{ height: '100%', width: '100%', gap: 1.5 }}>
      {items.map((item, index) => (
        <Skeleton key={index} width={`${item}%`} />
      ))}
    </Stack>
  ) : (
    children
  );
};
